define('OutSystems/ClientRuntime/modules/Database/AutoNumber',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var AutoNumber;
    (function (AutoNumber) {
        AutoNumber[AutoNumber["No"] = 0] = "No";
        AutoNumber[AutoNumber["Yes"] = 1] = "Yes";
        AutoNumber[AutoNumber["YesIfEmpty"] = 2] = "YesIfEmpty";
    })(AutoNumber || (AutoNumber = {}));
    exports.default = AutoNumber;
});
//# sourceMappingURL=AutoNumber.js.map;
